import { ColumnDef } from '@tanstack/react-table';
import { getAllCourts } from '@/services/Network';
import type { CourtResponse } from '@/types/court.types';

import { DataTable } from '@/components/DataTable';
import { OneLineText } from '@/components/OneLineText';
import { Edit3 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Courts = () => {
  const navigate = useNavigate();
  const columns: ColumnDef<CourtResponse>[] = [
    {
      accessorKey: 'code',
      header: 'Court Code',
      enableSorting: true,
      size: 180,
      cell: ({ row }) => {
        return <OneLineText className="mr-5 min-w-[200px]" text={row.original.code ?? '-'} />;
      },
    },
    {
      accessorKey: 'name',
      header: 'Court Name',
      enableSorting: true,
      size: 180,
      cell: ({ row }) => {
        return <OneLineText className="mr-5 min-w-[200px]" text={row.original.name ?? '-'} />;
      },
    },
    {
      accessorKey: 'type',
      header: 'Court Type',
      size: 120,
      cell: ({ row }) => {
        return <OneLineText className="mr-5 min-w-[200px]" text={row.original.type ?? '-'} />;
      },
    },
    {
      accessorKey: 'county',
      header: 'County',
      enableSorting: true,
      cell: ({ row }) => {
        return <OneLineText className="mr-5 min-w-[200px]" text={row.original.county ?? '-'} />;
      },
    },
    {
      accessorKey: 'state',
      header: 'State',
      enableSorting: true,
      cell: ({ row }) => {
        return <OneLineText className="mr-5 min-w-[100px]" text={row.original.state ?? '-'} />;
      },
    },
    {
      accessorKey: 'action',
      header: 'Action',
      cell: ({ row }) => {
        return (
          <div className="min-w-[100px] ">
            <Edit3
              className="cursor-pointer h-4 w-4 text-primary"
              onClick={() => {
                navigate(`/courts/update/${row.original.courtId}`);
              }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        apiGet={getAllCourts}
        toolbar={{
          toolBarTitle: 'Courts',
          addButton: true,
          addButtonTitle: 'Add Court',
          addOnClick: () => navigate('/courts/create'),
        }}
        search={[
          {
            label: 'Search Courts by Code',
            name: 'code',
            placeholder: 'Search Courts by Code ',
          },
          {
            label: 'Search Courts by Name',
            name: 'name',
            placeholder: 'Search Courts by Name ',
          },
          {
            label: 'Search Courts by Types',
            name: 'type',
            placeholder: 'Search Courts by Types',
          },
        ]}
      />
    </>
  );
};
